import 'angular:locale/data:en-US';
import './apps/authority-portal/src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-US";
